import { useEffect, useState } from "react";
import { api } from "../../api";
import { ErrorBanner, Panel } from "./ui";

export default function AdminOverview() {
  const [data, setData] = useState<any>(null);
  const [billing, setBilling] = useState<any>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([api.adminOverview(), api.adminBilling(24)])
      .then(([overview, reconciliation]) => {
        setData(overview);
        setBilling(reconciliation);
      })
      .catch((e) => setError(e.message));
  }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-black">全局概览</h1>
        <p className="mt-1 text-sm text-[#77705f]">平台小镇、用户、在线与 24 小时用量。</p>
      </div>
      <ErrorBanner message={error} />
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {[
          ["小镇", data?.towns?.total ?? "-", `活跃 ${data?.towns?.active ?? "-"} / 沉睡 ${data?.towns?.sleeping ?? "-"}`],
          ["用户", data?.users?.total ?? "-", `城主 ${data?.users?.mayor ?? "-"} / 玩家 ${data?.users?.player ?? "-"}`],
          ["当前在线", data?.online?.total ?? "-", `超管 ${data?.users?.superAdmin ?? "-"} 人`],
          ["24h LLM", (data?.llmUsage24h ?? 0).toLocaleString(), `平台 token 消耗 ${(data?.tokenConsumed24h ?? 0).toLocaleString()}`],
        ].map(([label, value, note]) => (
          <div key={String(label)} className="rounded-xl border border-[#ddd7c4] bg-white p-5 shadow-sm">
            <div className="text-sm text-[#77705f]">{label}</div>
            <div className="mt-2 text-3xl font-black text-[#203d34]">{value}</div>
            <div className="mt-2 text-xs text-[#928b78]">{note}</div>
          </div>
        ))}
      </div>
      <Panel title="镇在线分布">
        <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {Object.entries(data?.online?.byTown || {}).map(([townId, online]) => (
            <div key={townId} className="flex items-center justify-between rounded-lg bg-[#f7f5ed] px-3 py-2 text-sm">
              <code>{townId}</code>
              <span className="font-bold">{String(online)} 人在线</span>
            </div>
          ))}
          {!Object.keys(data?.online?.byTown || {}).length && <p className="text-sm text-[#88816f]">暂无已加载小镇。</p>}
        </div>
      </Panel>
      <Panel title="24 小时计费对账">
        <div className="flex flex-wrap items-center gap-3 text-sm">
          <span className={`rounded-md px-2.5 py-1 font-bold ${billing?.balanced ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>
            {billing?.balanced ? "账本一致" : "存在差异"}
          </span>
          <span className="text-[#665f4f]">最大容差 {billing?.tolerance ?? 1} token</span>
          <span className="text-[#665f4f]">绝对差合计 {Number(billing?.totalAbsDifference || 0).toLocaleString()}</span>
          <span className="text-[#665f4f]">待归集 {Number(billing?.pendingCharge || 0).toLocaleString()} token</span>
        </div>
        <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
          {(billing?.towns || []).map((town: any) => (
            <div key={town.townId} className="flex items-center justify-between rounded-lg bg-[#f7f5ed] px-3 py-2 text-sm">
              <span>
                <strong>{town.name}</strong>
                <span className="ml-2 text-xs text-[#8b8471]">{town.entries} 条 consume</span>
                <span className="ml-2 text-xs text-[#8b8471]">待归集 {Number(town.pendingCharge || 0).toLocaleString()}</span>
              </span>
              <span className={Math.abs(Number(town.difference || 0)) <= 1 ? "font-bold text-emerald-700" : "font-bold text-amber-700"}>
                差异 {Number(town.difference || 0).toLocaleString()}
              </span>
            </div>
          ))}
          {!billing?.towns?.length && <p className="text-sm text-[#88816f]">暂无可对账小镇。</p>}
        </div>
      </Panel>
    </div>
  );
}
